import { useEffect, useState } from "react";
import { AddIcon } from "../../../../data/iconImage";
import { useAlert } from "../../../../context/AlertContext";
import { filteredCreateNewKey } from "../../../../utils/ManageArray";
import {
  deleteServiceRequest,
  getServiceRequest
} from "../../../../commons/ServiceRequest";
import Table from "../../../../components/Table";
import ButtonLink from "../../../../components/ButtonLink";
import SearchFilter from "../../../../components/SearchFilter";
import ButtonOptionSubmenu from "../../../../components/ButtonOptionSubmenu";
import CardDisplayComponent from "../../../../components/CardDisplayComponent";
import ProdSetMcsService from "../../../../services/prodsetmc.service";

export default function AssignProductsBranchTab() {
  const { showAlert } = useAlert();
  const [loading, setLoading] = useState(false);
  const [data, setData] = useState([]);
  const [searchValue, setSearchValue] = useState([]);
  const searchInput = [
    {
      name: "Customer.Cus_Code",
      label: "รหัสลูกค้า/สาขา",
      classNames: { col: "mb-3", label: "mb-1" }
    },
    {
      name: "Customer.Cus_NumBranch",
      label: "เลขที่สาขา",
      classNames: { col: "mb-3", label: "mb-1" },
      size: 2
    },
    {
      name: "Customer.Cus_Name",
      label: "ชื่อสาขา",
      classNames: { col: "mb-3", label: "mb-1" },
      size: 7
    }
  ];
  const columns = [
    {
      name: "ลำดับ",
      selector: (row) => row.rowIndex,
      sortable: true,
      width: "110px"
    },
    {
      name: "รหัสสินค้า",
      selector: (row) => row.Item?.Item_Code,
      sortable: true,
      minWidth: "200px"
    },
    {
      name: "รายละเอียดสินค้า",
      selector: (row) => row.Item?.Item_Name_TH,
      minWidth: "300px"
    },
    {
      name: "หมายเลขเครื่อง (Serail No.)",
      selector: (row) => row.Item?.Item_Serial,
      minWidth: "270px"
    },
    {
      name: "หมายเลขเครื่องประจำสาขา",
      selector: (row) => row.Mc_No,
      minWidth: "270px"
    },
    { name: "Seq. Work", selector: (row) => row.Seq_Work, minWidth: "180px" },
    {
      name: "จุดติดตั้งเครื่อง",
      selector: (row) => row.Mc_Location,
      minWidth: "200px"
    },
    {
      name: "",
      selector: (row) => (
        <ButtonOptionSubmenu
          data={row}
          state={{ edit: { name: "machine" } }}
          editButton
          deleteButton
          onDeleteCallback={(event, { Id }) =>
            deleteServiceRequest({
              showAlert,
              setLoading,
              serviceRequest: ProdSetMcsService.deleteProdSetMcs(Id, true),
              refreshRequest: ProdSetMcsService.getAllProdSetMcs(),
              callback: (res) => setData(res)
            })
          }
        />
      ),
      center: true,
      width: "180px"
    }
  ];

  useEffect(() => {
    getServiceRequest({
      showAlert,
      setLoading,
      serviceRequest: ProdSetMcsService.getAllProdSetMcs(),
      callback: (res) => setData(res)
    });
  }, []);

  return (
    <>
      <CardDisplayComponent
        header={{
          title: { text: "ข้อมูลหมายเลขเครื่อง", className: "text-center" }
        }}
        body={{
          element: (
            <SearchFilter
              data={data}
              inputField={searchInput}
              fieldClassName={{
                inputRow: "justify-content-end",
                actionButton: "w-auto"
              }}
              searchCallback={(search) => {
                setSearchValue(
                  search.some(({ value }) => value)
                    ? filteredCreateNewKey({ data, search, newName: "Cus_Id" })
                    : []
                );
              }}
            />
          )
        }}
      />

      <CardDisplayComponent
        header={{
          className: "d-flex justify-content-between align-items-center",
          title: { text: "รายละเอียดสินค้าของสาขา" },
          button: (
            <ButtonLink
              linkTo="create"
              stateData={{ name: "machine" }}
              buttonName="สร้างหมายเลขเครื่อง"
              buttonClass="py-2 px-5 d-flex align-items-center rounded-pill"
              iconSrc={AddIcon}
              iconClass="me-2"
              iconName="Add Icon"
            />
          )
        }}
        body={{
          element: (
            <Table
              data={data}
              column={columns}
              searchFilter={searchValue}
              pending={loading}
            />
          )
        }}
      />
    </>
  );
}
